// extracted by mini-css-extract-plugin
export default {"icon":"AppointmentItem_icon__YoAm1","deleteButton":"AppointmentItem_deleteButton__FsR+G","editButton":"AppointmentItem_editButton__zl8rB"};